<div [id]="modalable.getModalId()" class="modal" data-backdrop="static"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center d-flex justify-content-center align-items-center flex-column gap-2">
                <ng-container>
                    <p class="text-center">
                        <img [attr.src]="assetService.getUrl('sidebar-quicklinks/digbi-logo.png')" width="200" height="auto" alt="Digbi Lernapp"/>
                    </p>
                    <p class="mt-3 text-uppercase font-weight-bold">Jetzt kostenlos testen</p>
                    <a [href]="modalable.contentUrl" target="_blank" rel="noopener noreferrer" class="btn btn-lem-green rounded-5 px-5">
                        1. Kapitel öffnen
                    </a>
                    @if (!modalable.isTeacher) {
                        <p class="mt-3">
                            Digbi Pro auf Store.at kaufen
                        </p>

                        <p>
                            @if (modalable.storeUrl) {
                                <a [href]="modalable.storeUrl" target="_blank" rel="noopener noreferrer" class="btn btn-buy-store">
                                    <img [attr.src]="'/sidebar-quicklinks/store-at-logo.png' | asset" alt="Icon der Shopping-Seite"/>
                                    auf Store.at kaufen
                                </a>
                            }
                        </p>
                    } @else {
                        <p class="mt-3">
                            Marktplatz Lernapps
                        </p>
                        <a [href]="modalable.storeUrl" target="_blank" rel="noopener noreferrer" class="btn btn-dark rounded-5">
                            Lernapp im Marktplatz aktivieren
                        </a>
                    }
                </ng-container>
            </div>
            <div class="modal-footer text-center justify-content-center">
                <button type="button" class="btn btn-back-to-book" data-bs-dismiss="modal">Zurück zum Buch</button>
            </div>
        </div>
    </div>
</div>
